import { Suspense } from 'react';
import { Outlet, useMatches } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import FullScreenHeader from '@/components/organisms/FullScreenHeader';
import BrandLoading from '@/components/organisms/BrandLoading';
import EntryReady from '@/components/atoms/EntryReady';
import type { ScreenKey } from '../screens';
import { usePageMotion } from '@/hooks/usePageMotion';
import { firstMvp } from '@/lib/productScope';

const HEADERLESS: ScreenKey[] = ['welcome', 'notFound'];

/** 상세/플로우의 뒤로 가기 헤더. 하단 메뉴 표시 여부는 공통 화면 정책을 따른다. */
export default function FullScreenLayout() {
  const { t } = useTranslation('screens');
  const motion = usePageMotion();
  const matches = useMatches();
  const screen = (matches.at(-1)?.handle as { screen?: ScreenKey } | undefined)
    ?.screen;

  const authStep = matches.at(-1)?.params.step;
  const mapDirectory = firstMvp && screen === 'exploreMap';
  const title =
    screen === 'auth' &&
    authStep &&
    ['sign-in', 'sign-up', 'reset-password'].includes(authStep)
      ? t(`auth:headers.${authStep}`)
      : screen
        ? t(screen)
        : undefined;

  return (
    <>
      {screen && !HEADERLESS.includes(screen) && !mapDirectory && (
        <FullScreenHeader title={title} />
      )}
      <main
        ref={motion}
        className={`gp-motion-scene flex flex-1 flex-col ${mapDirectory ? '' : 'pb-[var(--gp-bottom-nav-overhang,0px)]'}`}
      >
        <Suspense fallback={<BrandLoading />}>
          <Outlet />
          <EntryReady />
        </Suspense>
      </main>
    </>
  );
}
